import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import LDLOGO from '../assets/liderdistbrief.png';

const LoadingScreen = ({ message = 'Cargando...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#fff',
        gap: 3
      }}
    >
      <Box
        component="img"
        src={LDLOGO}
        alt="Liderdist Logo"
        sx={{ 
          width: 'auto',
          height: 50,
          mb: 2,
          animation: 'pulse 2s infinite'
        }}
      />
      <CircularProgress 
        size={40}
        sx={{ 
          color: '#ff5833',  // Liderdist orange
          mb: 2
        }}
      />
      <Typography 
        variant="h6" 
        sx={{ 
          color: 'text.secondary',
          fontWeight: 500,
          fontSize: '1rem'
        }}
      >
        {message}
      </Typography>

      <style>
        {`
          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.6;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default LoadingScreen; 